import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { get, isEmpty } from 'lodash';
import DynamicForm from 'screens/common/dynamicForm';
import { jwtDecode } from 'jwt-decode';
import { useNavigate, useParams } from 'react-router-dom';
import { FarmerGroupApi } from 'api/endpoints/FarmerGroup';
import { toast } from 'react-toastify';
import { formSubmissionToast } from 'helpers/utils';
import { getTenantFromToken } from 'utils/routeUtils';

const FarmerGroupForm = ({ edit }) => {
  const tenant = getTenantFromToken();
  const tns_tenant = '03534add672340809e2c70314b1ce20e';
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [tittle, setTittle] = useState('');
  const { id, groupId } = useParams();

  const fetchFormData = async () => {
    if (!edit) {
      try {
        const formResponse = await FarmerGroupApi.getCreateFarmerGroupForm(
          tns_tenant,
          id,
          edit // edit:false
        );
        setTittle(formResponse?.data?.results?.form?.title);
        setData(formResponse.data.results);
      } catch (error) {
        console.error('Error fetching form data:', error);
      }
    } else {
      fetchEditFormData();
    }
  };

  const fetchEditFormData = async () => {
    try {
      const formResponse = await FarmerGroupApi.getEditFarmerGroupForm(
        tns_tenant,
        edit,
        groupId
      );
      const formSchema = formResponse.data.results;
      const editResponse = await FarmerGroupApi.populateFarmerGroupEditForm(
        tns_tenant,
        groupId
      );

      if (editResponse?.data?.results) {
        const updatedFields = formSchema.fields.map(field => {
          if (field.table) {
            // Handle table field, replace rows with the data from the edit response
            const tableData = editResponse.data.results[field.id] || [];
            return {
              ...field,
              table: {
                ...field.table,
                rows: tableData.length > 0 ? tableData : field.table.rows // Replace with editResponse rows if available
              }
            };
          } else {
            return {
              ...field,
              defaultValue:
                editResponse.data.results[field.id] || field.defaultValue
            };
          }
        });

        formSchema.fields = updatedFields;
        setTittle(formResponse?.data?.results?.form?.title);
        setData(formSchema);
      }
    } catch (error) {
      console.error('Error fetching form data:', error);
    }
  };

  useEffect(() => {
    fetchFormData();
  }, [tns_tenant]);

  const handleFormSubmit = async formData => {
    let formatedData = {
      ...formData
    };
    try {
      if (edit) {
        const response = await FarmerGroupApi.updateFarmerGroupForm(
          tns_tenant,
          groupId,
          formatedData
        );
        formSubmissionToast(response, toast, 'Farmer Group', edit);
      } else {
        const response = await FarmerGroupApi.sendFarmerGroupCreate(
          tns_tenant,
          formatedData,
          id
        );
        formSubmissionToast(response, toast, 'Farmer Group', edit);
      }
      navigate(`/${tenant}/farmerGroupReport/`);
    } catch (err) {
      formSubmissionToast(err, toast, 'Farmer Group', edit);
    }
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate(`/${tenant}/farmerGroupReport`)}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>{tittle}</span>
    </div>
  );

  return (
    <Container>
      <Row>
        <Card className="mb-3">
          <Card.Header>
            <FalconCardHeader
              title={header}
              className="ps-lg-4"
              titleTag="h5"
              titleClass="mb-0"
              light
            />
          </Card.Header>
          <Card.Body>
            {!isEmpty(data) && (
              <DynamicForm
                data={data}
                header={true}
                onSubmit={handleFormSubmit}
              />
            )}
          </Card.Body>
        </Card>
      </Row>
    </Container>
  );
};

FarmerGroupForm.propTypes = {
  edit: PropTypes.bool
};

export default FarmerGroupForm;
